import { connect } from "react-redux";
import UserRequestView from "./RequestView";
import { bindActionCreators } from "redux";
import {userRequestById, approval, backToModificationRequest, backToModificationResponse} from "../../../services/redux/userHelpdesk/action";
import { documentUploadUrlPublic } from 'services/redux/fileUpload/action';

const mapStateToProps = (state) => ({
    requestByIdDetails : state.UserHelpdesk.requestByIdDetails,
    approvedResponse : state.UserHelpdesk.approvedResponse,
    modificationRequest : state.UserHelpdesk.modificationRequest,
    modificationResponse : state.UserHelpdesk.modificationResponse,
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({
        userRequestById,
        approval,
        documentUploadUrlPublic,
        backToModificationRequest,
        backToModificationResponse
    }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(UserRequestView);